var React = require('react');

function NavIconSalesEuro (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512M128 272h16c-.6-5-.9-10.1-.9-15.2 0-5.7.4-11.3 1.1-16.8H128c-8.8 0-16-7.2-16-16s7.2-16 16-16h24.7c19.2-46.9 65.4-80 119.2-80H313c13.3 0 24 10.7 24 24s-10.7 24-24 24h-41.1c-26.3 0-49.6 12.6-64.4 32H288c8.8 0 16 7.2 16 16s-7.2 16-16 16h-95.1c-1.1 5.4-1.7 11-1.7 16.8 0 5.2.5 10.3 1.4 15.2H288c8.8 0 16 7.2 16 16s-7.2 16-16 16h-81.6c14.7 20.3 38.5 33.5 65.5 33.5H313c13.3 0 24 10.7 24 24s-10.7 24-24 24h-41.1c-54.4 0-101-33.8-119.8-81.5H128c-8.8 0-16-7.2-16-16s7.2-16 16-16"}));
}

NavIconSalesEuro.defaultProps = {"viewBox":"0 0 512 512","fill":"currentColor"};

module.exports = NavIconSalesEuro;

NavIconSalesEuro.default = NavIconSalesEuro;
